import { useEffect, useRef, useState } from 'react';

/**
 * Keeps a boolean `true` for at least `ms` once it becomes `true`,
 * and freezes `data` during the hold period to prevent list updates
 * while the spinner is still visible.
 */
export function useMinDelay<T>(value: boolean, data: T, ms: number): { pending: boolean; data: T } {
  const [ holding, setHolding ] = useState(value);
  const [ prevValue, setPrevValue ] = useState(value);
  const [ heldData, setHeldData ] = useState(data);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  if (value !== prevValue) {
    setPrevValue(value);

    if (value) {
      setHolding(true);
      setHeldData(data);
    }
  }

  useEffect(() => {
    if (value) {
      clearTimeout(timeoutRef.current);
    } else if (holding) {
      timeoutRef.current = setTimeout(() => setHolding(false), ms);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [ value, holding, ms ]);

  const pending = value || holding;

  return { pending, data: pending ? heldData : data };
}
